import GlobalStore from '@store/globalStore';
import { atom } from 'jotai';

export const showSkillLevelInfoPopup = atom(false);

export const showCalculatingSkillLevelInfoPopup = atom(false);

export const forceHideTimedWorksheetPopup = atom(false);

export function resetSkillLevelState() {
  GlobalStore.set(showSkillLevelInfoPopup, false);
}

// reset to default state at start
resetSkillLevelState();
